import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { canonicalizeCountryCode } from "@/constants/billingCatalog";
import { usePublicBillingCatalog } from "@/hooks/usePublicBillingCatalog";
import { fromPriceLine, minimumCatalogOffer } from "@/lib/landingCatalogCopy";
import {
  LandingCountryDetectProvider,
  useLandingCountryDetect,
} from "../roofingLight/landingCountryDetect";
import QuietNavbar from "./shared/QuietNavbar.jsx";
import QuietFooter from "./shared/QuietFooter.jsx";
import QuietHero from "./sections/QuietHero.jsx";
import MadeByRoofersSection from "./sections/MadeByRoofersSection.jsx";
import ExpertiseSection from "./sections/ExpertiseSection.jsx";
import ComparisonSection from "./sections/ComparisonSection.jsx";
import NotForSection from "./sections/NotForSection.jsx";
import PricingSection from "./sections/PricingSection.jsx";
import TestDriveSection from "./sections/TestDriveSection.jsx";
import QuietChannelsSection from "./sections/QuietChannelsSection.jsx";
import { CaseStudySection, FounderQuoteSection } from "./caseStudy";
import { LiveProofSection } from "./liveProof";
import QuietInterceptSection from "./sections/QuietInterceptSection.jsx";
import LeadInterceptionSection from "./sections/LeadInterceptionSection.jsx";
import QuietClosingCta from "./sections/QuietClosingCta.jsx";
import LeadCaptureModal from "./modal/LeadCaptureModal.jsx";
import DemoCallModal from "./modal/DemoCallModal.jsx";

const MainLanding = () => {
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const catalogCountry = canonicalizeCountryCode(searchParams.get("country"));
  const { status: catalogStatus, catalog } = usePublicBillingCatalog(catalogCountry);
  const detection = useLandingCountryDetect();
  const priceOffer = minimumCatalogOffer(catalog?.items);
  const entryLine = priceOffer
    ? fromPriceLine(priceOffer.amount_minor, priceOffer.currency)
    : null;

  const openLeadModal = () => setIsLeadModalOpen(true);
  const closeLeadModal = () => setIsLeadModalOpen(false);
  const openDemoModal = () => setIsDemoModalOpen(true);
  const closeDemoModal = () => setIsDemoModalOpen(false);

  return (
    <LandingCountryDetectProvider value={detection}>
      <div className="quiet-landing roofing-digital-employee-landing min-h-screen" data-testid="quiet-landing">
        <QuietNavbar onSignUp={openLeadModal} />
        <div className="h-14 md:h-16" aria-hidden="true" />
        <div className="cursor-grid-shell">
          <main>
            <QuietHero onOpenModal={openLeadModal} />
            <MadeByRoofersSection onOpenModal={openLeadModal} />
            <ExpertiseSection />
            <ComparisonSection />
            <NotForSection />
            <PricingSection
              onOpenModal={openLeadModal}
              entryOffer={priceOffer}
              catalogStatus={catalogStatus}
            />
            <TestDriveSection onOpenModal={openLeadModal} />
            <QuietChannelsSection />
            <QuietInterceptSection />
            <LiveProofSection />
            <CaseStudySection />
            <FounderQuoteSection />
            <LeadInterceptionSection />
            <QuietClosingCta onOpenModal={openLeadModal} onOpenDemoModal={openDemoModal} />
          </main>
          <QuietFooter />
        </div>
        <LeadCaptureModal isOpen={isLeadModalOpen} onClose={closeLeadModal} entryLine={entryLine} catalogStatus={catalogStatus} />
        <DemoCallModal isOpen={isDemoModalOpen} onClose={closeDemoModal} />
      </div>
    </LandingCountryDetectProvider>
  );
};

export default MainLanding;
